import React, { useEffect } from 'react';
import './App.css';
import { BrowserRouter, Routes, Route, Navigate } from 'react-router-dom';
import axios from 'axios';
import { installSessionRefresh } from './lib/session';
import AssistantWorkspace from './components/support/AssistantWorkspace';

// Public Pages
import Landing from './pages/Landing';
import Login from './pages/Login';
import Admin from './pages/Admin';
import Privacy from './pages/Privacy';
import Terms from './pages/Terms';
import DataDeletion from './pages/DataDeletion';
import ForgotPassword from './pages/ForgotPassword';
import ResetPassword from './pages/ResetPassword';
import Onboarding from './pages/Onboarding';

// Admin Dashboard
import SupportAssistant from './pages/dashboard/SupportAssistant';

// Dashboard Pages
import Dashboard from './pages/dashboard/Dashboard';
import ClinicSetup from './pages/dashboard/ClinicSetup';
import AIConfig from './pages/dashboard/AIConfig';
import Training from './pages/dashboard/Training';
import Leads from './pages/dashboard/Leads';
import Appointments from './pages/dashboard/Appointments';
import Conversations from './pages/dashboard/Conversations';
import Integrations from './pages/dashboard/Integrations';
import Subscription from './pages/dashboard/Subscription';
import Team from './pages/dashboard/Team';
import Reviews from './pages/dashboard/Reviews';
import MetaAds from './pages/dashboard/MetaAds';
import MetaCAPI from './pages/dashboard/MetaCAPI';
import TikTokAds from './pages/dashboard/TikTokAds';
import GoogleAds from './pages/dashboard/GoogleAds';
import MassMessaging from './pages/dashboard/MassMessaging';
import WhatsAppSetup from './pages/dashboard/WhatsAppSetup';
import MessengerSetup from './pages/dashboard/MessengerSetup';
import SocialComments from './pages/dashboard/SocialComments';
import OwnerNotice from './pages/dashboard/OwnerNotice';
import HotLeads from './pages/dashboard/HotLeads';
import BulkEmail from './pages/dashboard/BulkEmail';

// Renew the 15-minute access token from the refresh cookie; log out only if that fails.
installSessionRefresh(axios);

// Auth Guard
const PrivateRoute = ({ children }) => {
  const token = localStorage.getItem('token');
  const clinicId = localStorage.getItem('clinicId');
  
  // Both token and clinicId must exist
  if (!token || !clinicId) {
    console.log('🔒 Missing credentials, redirecting to login');
    return <Navigate to="/login" />;
  }
  
  return children;
};

function App() {
  return (
    <BrowserRouter>
      <AssistantWorkspace>
      <Routes>
        {/* Public */}
        <Route path="/" element={<Landing />} />
        <Route path="/login" element={<Login />} />
        <Route path="/forgot-password" element={<ForgotPassword />} />
        <Route path="/reset-password" element={<ResetPassword />} />
        <Route path="/admin" element={<Admin />} />
        <Route path="/privacy" element={<Privacy />} />
        <Route path="/terms" element={<Terms />} />
        <Route path="/data-deletion" element={<DataDeletion />} />
        <Route path="/onboarding" element={<PrivateRoute><Onboarding /></PrivateRoute>} />
        
        {/* Super Admin Dashboard */}
        <Route path="/super-admin" element={<Navigate to="/admin" replace />} />
        <Route path="/dashboard/assistant" element={<PrivateRoute><SupportAssistant /></PrivateRoute>} />
        
        {/* Dashboard */}
        <Route path="/dashboard" element={<PrivateRoute><Dashboard /></PrivateRoute>} />
        <Route path="/dashboard/clinic" element={<PrivateRoute><ClinicSetup /></PrivateRoute>} />
        <Route path="/dashboard/ai" element={<PrivateRoute><AIConfig /></PrivateRoute>} />
        <Route path="/dashboard/training" element={<PrivateRoute><Training /></PrivateRoute>} />
        <Route path="/dashboard/leads" element={<PrivateRoute><Leads /></PrivateRoute>} />
        <Route path="/dashboard/appointments" element={<PrivateRoute><Appointments /></PrivateRoute>} />
        <Route path="/dashboard/conversations" element={<PrivateRoute><Conversations /></PrivateRoute>} />
        <Route path="/dashboard/integrations" element={<PrivateRoute><Integrations /></PrivateRoute>} />
        <Route path="/dashboard/subscription" element={<PrivateRoute><Subscription /></PrivateRoute>} />
        <Route path="/dashboard/reviews" element={<PrivateRoute><Reviews /></PrivateRoute>} />
        <Route path="/dashboard/meta-ads" element={<PrivateRoute><MetaAds /></PrivateRoute>} />
        <Route path="/dashboard/meta-capi" element={<PrivateRoute><MetaCAPI /></PrivateRoute>} />
        <Route path="/dashboard/tiktok-ads" element={<PrivateRoute><TikTokAds /></PrivateRoute>} />
        <Route path="/dashboard/google-ads" element={<PrivateRoute><GoogleAds /></PrivateRoute>} />
        <Route path="/dashboard/team" element={<PrivateRoute><Team /></PrivateRoute>} />
        <Route path="/dashboard/mass-messaging" element={<PrivateRoute><MassMessaging /></PrivateRoute>} />
        <Route path="/dashboard/whatsapp-setup" element={<PrivateRoute><WhatsAppSetup /></PrivateRoute>} />
        <Route path="/dashboard/messenger-setup" element={<PrivateRoute><MessengerSetup /></PrivateRoute>} />
        <Route path="/dashboard/owner-notices/:reference" element={<PrivateRoute><OwnerNotice /></PrivateRoute>} />
        <Route path="/dashboard/social-comments" element={<PrivateRoute><SocialComments /></PrivateRoute>} />
        <Route path="/dashboard/hot-leads" element={<PrivateRoute><HotLeads /></PrivateRoute>} />
        <Route path="/dashboard/bulk-email" element={<PrivateRoute><BulkEmail /></PrivateRoute>} />
      </Routes>
      </AssistantWorkspace>
    </BrowserRouter>
  );
}

export default App;


